"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (props) {
    return _react2.default.createElement(
        "svg",
        { width: "38", height: "38", viewBox: "0 0 38 38", className: "Icon toolbar-quote-on", xmlns: "http://www.w3.org/2000/svg" },
        _react2.default.createElement(
            "g",
            { transform: "translate(1 1)", fill: "none", fillRule: "evenodd" },
            _react2.default.createElement("rect", { stroke: "#000", width: "36", height: "36", rx: "3", strokeWidth: "2" }),
            _react2.default.createElement("path", { d: "M13.484 17.68c.108-1.764 1.26-2.7 3.852-3.024V13C12.872 13.252 11 15.7 11 18.976c0 2.232 1.08 3.708 3.06 3.708 1.62 0 2.7-1.08 2.7-2.592 0-1.368-.684-2.196-1.872-2.412h-1.404zM21.484 17.68c.108-1.764 1.26-2.7 3.852-3.024V13C20.872 13.252 19 15.7 19 18.976c0 2.232 1.08 3.708 3.06 3.708 1.62 0 2.7-1.08 2.7-2.592 0-1.368-.684-2.196-1.872-2.412h-1.404z", fill: "#4C4C4C" })
        )
    );
}; /*eslint-disable */


//////////////////
// WEBPACK FOOTER
// ./src/client/components/icons/large/jsx/toolbar-quote-on.js
// module id = 1850
// module chunks = 0